import Row from '../Row';
import * as ids from '../../../layerIdStrings';

export default [
	{
		component: Row,
		props: {
			id: ids.DIALECTS_COARSE,
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: ids.DIALECTS_COARSE,
			name: 'Makroareály',
			initial: true,
			icon: false,
			inputName: 'dialects',
			inputType: 'radio',
		}
	},
	{
		component: Row,
		props: {
			id: ids.DIALECTS_FINE,
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: ids.DIALECTS_FINE,
			name: 'Podrobnejšie nárečové členenie<br>(skupiny, areály, mikroareály)',
			initial: false,
			icon: false,
			inputName: 'dialects',
			inputType: 'radio',
		}
	},
	{
		component: Row,
		props: {
			id: ids.DIALECTS_NONE,
			type: 'overlay',
			category: 'layer',
			className: 'js-layer',
			value: ids.DIALECTS_NONE,
			name: 'Nezobrazovať',
			initial: false,
			icon: false,
			inputName: 'dialects',
			inputType: 'radio',
		}
	},
];
